module.exports = __webpack_public_path__ + "assets/img/item.4ed4e28c.svg";